import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type CheckboxBase from "@/components/Checkbox.Base.vue";

export default defineMosaicComponent<typeof CheckboxBase>("components/Checkbox");
